import { render } from "./TheFooter.vue?vue&type=template&id=61bc2f78&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=61bc2f78&scoped=true&lang=scss"

import exportComponent from "D:\\Projekty\\Elektromeck\\electro-meck-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61bc2f78"]])

export default __exports__